import React, { useMemo, useState } from 'react'

import { Button, Popover } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import ClickableIcon from '../Buttons/ClickableIcon'

import '../../../assets/quotas.scss'

const PopoverIcon = ({ color, content, icon, title, onConfirm }) => {
  const t = useSelector(selectTranslate)

  const [visible, setVisible] = useState(false)

  const popoverContent = useMemo(() => (
    <div>
      <div className='popover-icon-button-content'>
        {t(content)}
      </div>
      <div className='popover-icon-button-default-actions'>
        <div className='popover-icon-button-action'>
          <Button
            key='card-save-button'
            onClick={onConfirm}
          >
            {t('Yes')}
          </Button>
        </div>
        <div className='popover-icon-button-action'>
          <Button
            key='card-cancel-button'
            onClick={() => setVisible(false)}
          >
            {t('No')}
          </Button>
        </div>
      </div>
    </div>
  ), [t, content, onConfirm])

  return (
    <div>
      <Popover
        overlayClassName='popover-icon-button'
        content={popoverContent}
        title={t(title)}
        trigger='click'
        visible={visible}
      >
        <ClickableIcon
          icon={icon}
          color={color}
          onClick={() => setVisible(true)}
        />
      </Popover>
    </div>
  )
}

export default PopoverIcon
